import * as Sentry from '@sentry/react';

const normalizeToError = (value, context) => {
  if (value instanceof Error) return value;
  if (typeof value === 'string') return new Error(value);

  // GraphQL errors (from Apollo `graphQLErrors`) are often plain objects with
  // fields like { message, locations, path, extensions, ... }.
  const message = value?.message ?? value?.extensions?.message ?? 'Unknown GraphQL error';
  const err = new Error(message);
  const operationName = context?.apolloOperationName;
  err.name = operationName ? `GraphQLError [${operationName}]` : 'GraphQLError';
  return err;
};

// Tags are indexed and length-capped, so a JSON blob dumped into one is both
// truncated and searchable. Contexts are neither, which is where arbitrary
// call-site detail belongs.
export const applyContext = (scope, context) => {
  if (context === undefined || context === null) return;
  if (typeof context === 'object') {
    scope.setContext('appContext', context);
  } else {
    scope.setExtra('appContext', context);
  }
};

export const captureSentryError = ({
  error,
  info,
  userId,
  accountId,
  applicationTypeId,
  context,
}) => {
  if (import.meta.env.REACT_APP_SENTRY_DSN) {
    Sentry.withScope((scope) => {
      scope.setUser({
        id: userId || 'unavailable',
      });
      scope.setTag('accountId', accountId || 'unavailable');
      scope.setTag('applicationTypeId', applicationTypeId || 'unavailable');
      scope.setTag('pathname', window.location.pathname);
      applyContext(scope, context);

      if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        scope.setExtra('originalException', error);
        Sentry.captureException(normalizeToError(error));
      }
    });
    // eslint-disable-next-line no-console
    console.log('Error log sent');
  } else {
    // eslint-disable-next-line no-console
    console.log('error is: ', error, info);
  }
};

export const captureSentryGenericError = (error, context) => {
  if (
    // import.meta.env.PROD &&
    !window.Cypress &&
    import.meta.env.MODE !== 'ci' &&
    import.meta.env.REACT_APP_SENTRY_DSN
  ) {
    Sentry.withScope((scope) => {
      applyContext(scope, context);

      // Apollo/GraphQL often passes a plain object; Sentry expects an Error.
      if (error instanceof Error) {
        Sentry.captureException(error);
      } else {
        scope.setExtra('originalException', error);
        Sentry.captureException(normalizeToError(error, context));
      }
    });
    // eslint-disable-next-line no-console
    console.log('Error log sent');
  } else {
    // eslint-disable-next-line no-console
    console.log('error is: ', error);
  }
};
